<router-outlet></router-outlet>
<app-loader *ngIf="loading$ | async"></app-loader>